import RentingPreparationMobileList from '@/components/RentingPreparationMobile/RentingPreparationMobileList'
import RentingPreparationMobileDetail from '@/components/RentingPreparationMobile/RentingPreparationMobileDetail'

let RentingPreparationMobileRouter = [{
    path: '/renting_preparation_mobile',
    name: 'RentingPreparationMobileList',
    component: RentingPreparationMobileList,
    meta: {
      title: 'Préparations',
      requiresAuth: true,
      authorizations: ['renting-preparation_index', 'mobile_access']
    }
  },
  {
    path: '/renting_preparation_mobile/:id',
    name: 'RentingPreparationMobileDetail',
    component: RentingPreparationMobileDetail,
    meta: {
      title: 'Fiche préparation',
      requiresAuth: true,
      authorizations: ['renting-preparation_show', 'mobile_access']
    }
  }
]

export default RentingPreparationMobileRouter



// WEBPACK FOOTER //
// ./src/components/RentingPreparationMobile/router.js